// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

const firebaseConfig = {
  apiKey: "AIzaSyDyhwg5UjVXIEk_c_GhWP1nGwnNTXXUfOM",
  authDomain: "previonix-703f7.firebaseapp.com",
  projectId: "previonix-703f7",
  storageBucket: "previonix-703f7.firebasestorage.app",
  messagingSenderId: "786903032360",
  appId: "1:786903032360:web:096016ac87061f5116cb1d",
  measurementId: "G-KNDEM8DBVH",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export async function requestPermissionAndToken() {
  try {
    if (typeof Notification === "undefined") {
      return { token: null, permission: "unsupported" };
    }

    let permission = Notification.permission;

    // Solo pedir permiso si el usuario aún no decidió
    if (permission === "default") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      console.warn("Permiso de notificaciones no concedido");
      return { token: null, permission };
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BEsZwKsO8bAVJ7G4vSFeIBAFNfvtPYQLFGK5Qi0HKXD2rXsEJyZwft5wrEvLaSZlivnaHv8ekc5VBQWFOVhUEEQ",
    });

    return { token, permission };
  } catch (err) {
    return { token: null, permission: "error" };
  }
}

export function listenForegroundMessages(onNotification) {
  onMessage(messaging, (payload) => {
    const title = payload.notification?.title || payload.data?.title;
    const body = payload.notification?.body || payload.data?.body;

    toast.info(`${title}: ${body}`, { autoClose: 3000 });
    if (typeof onNotification === "function") onNotification(payload);
  });
}
